import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ReversaPagoService } from 'src/app/services/reversa-pago.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalAddEditReversoPagoComponent } from '../modal-add-edit-reverso-pago/modal-add-edit-reverso-pago.component';
import * as _ from 'lodash'

@Component({
  selector: 'app-reverso-pagos-detalles',
  templateUrl: './detalles.component.html',
  styleUrls: ['./detalles.component.scss']
})
export class DetallesComponent implements OnInit {

  // Modales
  @ViewChild(ModalAddEditReversoPagoComponent, { static: true }) modalReverso: ModalAddEditReversoPagoComponent

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  loadAll: boolean = false
  listaReversos: any = null
  inputParams: any = null
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false
  loaded: boolean = false

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private rutService: RutService,
    private messageRendererService: MessageRendererService,
    private reversaPagoService: ReversaPagoService,
    private fileDownloadService: FileDownloadService
  ) {
    this.log = this.clog.log('INVENTARIO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())

    this.paginationContext.RecordsByPage = 10
  }

  loadData({ rutCliente, fechaDesde, fechaHasta }) {
    this.listaReversos = null
    this.paginationContext.CurrentPage = 1
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        cliente_proveedor_rut: rutCliente != null ? this.rutService.QuitarDV(rutCliente) : null,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta
      },
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
    this.inputParams = inputParams
    this.loadAll = false
    this.buscar()
  }

  loadAllData() {
    this.listaReversos = null
    this.paginationContext.CurrentPage = 1
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa
      },
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
    this.inputParams = inputParams
    this.loadAll = true
    this.buscar()
  }

  buscar() {
    this.inputParams.paginaActual = this.paginationContext.CurrentPage
    this.log('process.env.NODE_ENV', process.env.NODE_ENV)
    this.log('inputParams', JSON.stringify(this.inputParams))
    if (this.loadAll) {
      this.reversaPagoService.obtenerTodosReversos(this.inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }
        this.handleReversosResult(respuesta)
      })
    } else {
      this.reversaPagoService.obtenerSegunFiltro(this.inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }
        this.handleReversosResult(respuesta)
      })
    }
  }

  handleReversosResult(respuesta) {
    const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
    this.paginationContext.RecordsCount = totalRegistros
    this.paginationContext.CurrentPage = paginaActual
    this.paginationContext.PagesCount = totalPaginas
    this.listaReversos = registros

    this.listaReversos.forEach(reverso => {
      reverso.rutClienteFormato = this.rutService.AgregarDV(reverso.cliente_proveedor_rut)
    });
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage
    this.buscar()
  }

  openModalReverso() {
    this.modalReverso.show()
  }

  loadModalReverso(codigo: number) {
    this.modalReverso.loadAndShow(codigo)
  }

  downloadExcel() {
    const inputParams = _.cloneDeep(this.inputParams)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    this.reversaPagoService.obtenerExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.rutaArchivo)
    })
  }

}
